var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _vm.$bem("input") }, [
    _c("div", { class: _vm.$bem("input-field") }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text",
          },
        ],
        attrs: {
          autofocus: _vm.autoFocus,
          placeholder: _vm._f("translate")("search"),
          type: "text",
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.text },
        on: {
          keydown: function ($event) {
            return _vm.onKeyDown($event)
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.text = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.showClear
        ? _c("span", {
            class: _vm.$bem("clear-search"),
            on: {
              click: function ($event) {
                return _vm.$emit("reset")
              },
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [_vm.$bem("input-btn"), this.active ? "active" : ""],
        on: {
          click: function ($event) {
            return _vm.submitText()
          },
        },
      },
      [
        _c("span", { class: _vm.$bem("input-btn-text") }, [
          _vm._v(_vm._s(_vm._f("translate")("search-button"))),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$bem("input-btn-icon") }, [
          _c(
            "svg",
            {
              attrs: {
                fill: "#FFFFFF",
                height: "30px",
                width: "30px",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", { attrs: { d: "M0 0h24v24H0V0z", fill: "none" } }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
                },
              }),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.googleResults.length > 0
      ? _c(
          "ul",
          { class: _vm.$bem("google-result-list") },
          _vm._l(_vm.googleResults, function (result) {
            return _c(
              "li",
              {
                class: _vm.$bem("google-result"),
                on: {
                  click: function ($event) {
                    return _vm.clickOnGoogleResult(result)
                  },
                },
              },
              [_vm._v(_vm._s(result.description) + "\n            ")]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }